<template>
  <el-dialog
    :title="curTitle"
    :visible.sync="dialogVisible"
    width="530px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    lock-scroll
    destroy-on-close
    @close="closeWin(0)"
  >
    <transition name="el-zoom-in-center">
      <div v-show="formType==='login'" class="transition-box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="loginForm">
          <el-form-item label="" >
            <div style="text-align: center">
              <el-radio-group v-model="ruleForm.userType" size="medium">
                <el-radio-button label="b2c">{{$t('util.khdl')}}</el-radio-button>
                <el-radio-button label="b2b">{{$t('util.thdl')}}</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item :label="ruleForm.userType === 'b2b' ? $t('util.yhm') : 'Email'" prop="userName">
            <el-input v-model.trim="ruleForm.userName" :placeholder="ruleForm.userType === 'b2b' ? $t('util.yhmdesc') : 'Email'" size="medium" />
          </el-form-item>
          <el-form-item :label="$t('util.mm')" prop="passwd">
            <el-input v-model="ruleForm.passwd" show-password :placeholder="$t('util.mmdesc')" size="medium" type="password" />
          </el-form-item>
          <el-form-item label="" prop="agree">
            <div class="agreeRow">
              <el-checkbox v-model="ruleForm.agree" :label="$t('util.ty')" name="type" :true-label="1" :false-label="0" />
              <router-link to="/article/3" target="_blank">
                <el-link :underline="false">《{{$t('util.tkxz')}}》</el-link>
              </router-link>
              <span> 和 </span>
              <router-link to="/article/3" target="_blank">
                <el-link :underline="false">《{{$t('util.ystk')}}》</el-link>
              </router-link>
              <span>。</span>
            </div>
          </el-form-item>
          <el-form-item label="" >
            <el-button type="success" size="medium" style="width: 100%" plain @click="fnLogin">{{$t('util.ljdl')}}</el-button>
            <p style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width:100%;" v-if="ruleForm.userType === 'b2c'">
              <el-link :underline="false" style="color: #2d5ae6" @click="formType='reg'">&lt;{{$t('util.myzh')}}</el-link>
              <el-link :underline="false" style="color: #727272" @click="formType='forget'">{{$t('util.wjmm')}}&gt;</el-link>
            </p>
          </el-form-item>
          <el-form-item label="" v-if="ruleForm.userType === 'b2c'">
            <el-divider>{{$t('util.htgdsfzhdr')}}</el-divider>
            <div class="rd3Login">
              <el-image src="https://tourimage.huayitraveltd.com/static/wechat.png" class="btn" fit="cover" @click="rd3WxLogin('wechat')" />
              <el-image src="https://tourimage.huayitraveltd.com/static/alilogo.png" class="btn" fit="cover" @click="rd3WxLogin('ali')" />
              <el-image src="https://tourimage.huayitraveltd.com/static/qqlogo.png" class="btn" fit="cover" @click="rd3WxLogin('qq')" />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="formType==='reg'" class="transition-box">
        <el-form :model="regForm" :rules="rules" ref="regForm" label-position="top" class="loginForm">
          <el-form-item label="Email" prop="email">
            <el-input v-model.trim="regForm.email" placeholder="Email" size="medium" />
          </el-form-item>
          <el-form-item :label="$t('util.mm')" prop="passwd">
            <el-input v-model="regForm.passwd" show-password :placeholder="$t('util.mmdesc')" size="medium" type="password" />
          </el-form-item>
          <el-form-item label="" prop="agree">
            <div class="agreeRow">
              <el-checkbox v-model="regForm.agree" :label="$t('util.ty')" name="type" :true-label="1" :false-label="0" />
              <router-link to="/article/3" target="_blank">
                <el-link :underline="false">《{{$t('util.tkxz')}}》</el-link>
              </router-link>
              <span> 和 </span>
              <router-link to="/article/3" target="_blank">
                <el-link :underline="false">《{{$t('util.ystk')}}》</el-link>
              </router-link>
              <span>。</span>
            </div>
          </el-form-item>
          <el-form-item label="" >
            <el-button type="success" size="medium" style="width: 100%" plain @click="fnReg">{{$t('util.ljzc')}}</el-button>
            <p style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width:100%;" >
              <el-link :underline="false" style="color: #2d5ae6" @click="formType='login'">&lt;{{$t('util.yyzh')}}</el-link>
            </p>
          </el-form-item>
        </el-form>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="formType==='forget'" class="transition-box">
        <el-form :model="forgetForm" :rules="rules" ref="forgetForm" label-position="top" class="loginForm">
          <el-form-item label="Email" prop="email">
            <el-input v-model.trim="forgetForm.email" placeholder="Email" size="medium" >
              <template #append>
                <el-button size="mini" @click="sendCode" :disabled="!canSend" style="width: 110px">{{sendTxt}}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('util.yzm')" prop="verifyCode">
            <el-input v-model.trim="forgetForm.verifyCode" :placeholder="$t('util.qsryzm')" size="medium" />
          </el-form-item>
          <el-form-item :label="$t('util.mm')" >
            <el-input v-model="forgetForm.passwd" show-password :placeholder="$t('util.mmdesc')" size="medium" type="password" :disabled="forgetForm.verifyCode === ''" />
          </el-form-item>
          <el-form-item label="" >
            <el-button type="success" size="medium" style="width: 100%" plain @click="fnForget" :disabled="forgetForm.verifyCode === ''">{{$t('util.ljcz')}}</el-button>
            <p style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width:100%;" >
              <el-link :underline="false" style="color: #2d5ae6" @click="formType='login'">&lt;{{$t('util.yyzh')}}</el-link>
            </p>
          </el-form-item>
        </el-form>
      </div>
    </transition>
  </el-dialog>
</template>

<script>
import md5 from 'js-md5'
import {login, userReg, forgetPwd, forgetPwdChkCode, forgetPwdSetByCode} from '../../service/util'
var oauthWin
var codeCtx
export default {
  name: 'LoginBox',
  data () {
    return {
      cdVal: 60,
      formType: 'login',
      canSend: true,
      chkCode: false,
      dialogVisible: false,
      ruleForm: {
        userType: 'b2c',
        userName: '',
        passwd: '',
        agree: 0
      },
      regForm: {
        email: '',
        passwd: '',
        agree: 0
      },
      forgetForm: {
        email: '',
        passwd: '',
        verifyCode: '',
        agree: 0
      }
    }
  },
  computed: {
    curTitle () {
      return this.formType === 'login' ? '登錄' : (this.formType === 'reg' ? '註冊' : '忘記密碼')
    },
    sendTxt () {
      return this.canSend ? this.$t('util.fsyzm') : this.cdVal
    },
    rules () {
      return {
        userName: [{required: true, message: this.$t('util.yhmdesc'), trigger: 'blur'}],
        passwd: [{required: true, message: this.$t('util.mmdesc'), trigger: 'blur'}],
        agree: [{required: true, validator: this.isAgree, trigger: 'change'}],
        email: [{required: true, message: '請輸入email', type: 'email', trigger: 'blur'}]
      }
    }
  },
  destroyed () {
    window.removeEventListener('message', this.onMessage)
  },
  methods: {
    fnForget () {
      if (this.forgetForm.verifyCode !== '') {
        forgetPwdChkCode(this.forgetForm.email, this.forgetForm.verifyCode).then(res => {
          if (res.code === 200) {
            forgetPwdSetByCode(res.data, this.forgetForm.passwd).then(res => {
              if (res.code === 200) {
                this.$notify.success('操作成功')
                this.formType = 'login'
              } else {
                this.$notify.warning(res.data)
              }
            })
          } else {
            this.$notify.warning(res.data)
          }
        })
      }
    },
    sendCode () {
      if (this.canSend) {
        forgetPwd(this.forgetForm.email).then(res => {
          if (res.code === 200) {
            this.countDown()
          } else {
            this.$notify.warning(res.data)
          }
        })
      }
    },
    countDown () {
      this.cdVal--
      if (codeCtx) clearTimeout(codeCtx)
      this.canSend = false
      if (this.cdVal > 0) {
        codeCtx = setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.canSend = true
        this.cdVal = 60
      }
    },
    onMessage (e) {
      if (e.origin === 'https://apitour.huayitraveltd.com') {
        const data = JSON.parse(e.data)
        this.setToken({
          val: data.token,
          exp: data.userInfo.expTime
        })
        this.setUserInfo({
          id: data.userInfo.uid,
          userName: data.userInfo.userName,
          trueName: data.userInfo.trueName ? data.userInfo.nickName : data.userInfo.trueName,
          nickName: data.userInfo.nickName,
          mobile: data.userInfo.mobile,
          jifen: data.userInfo.jifen,
          avatarUrl: data.userInfo.avatarUrl,
          email: data.userInfo.email
        })
        oauthWin.close()
        this.closeWin(1)
        console.log('receive message->', e)
      }
    },
    rd3WxLogin (way) {
      window.addEventListener('message', this.onMessage)
      oauthWin = window.open('https://apitour.huayitraveltd.com/oauth/' + way, '_blank', 'nodeIntegration=no')
    },
    isAgree (rule, value, callback) {
      if (value !== 1) {
        callback(new Error(this.$t('util.qxtytkxz').toString()))
      } else {
        callback()
      }
    },
    fnReg () {
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          userReg(this.regForm.email, this.regForm.passwd).then(res => {
            if (res.code === 200) {
              this.$notify.success('註冊成功')
              this.formType = 'login'
            } else {
              this.$notify.warning(res.data)
            }
          })
        }
      })
    },
    fnLogin () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const vLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            fullscreen: true
          })
          login(this.ruleForm.userName, md5(this.ruleForm.passwd), this.ruleForm.userType).then(res => {
            if (res.code !== 200) {
              this.$notify.error(res.data)
            } else {
              this.setUserType(this.ruleForm.userType.toUpperCase())
              const token = res._headers.authorization
              const userInfo = res.data
              this.setToken({
                val: token,
                exp: userInfo.expTime
              })
              if (this.VuserType === 'B2C') {
                this.setUserInfo({
                  id: userInfo.uid,
                  userName: userInfo.userName,
                  trueName: userInfo.trueName,
                  nickName: userInfo.nickName,
                  mobile: userInfo.mobile,
                  jifen: userInfo.jifen,
                  avatarUrl: userInfo.avatarUrl,
                  email: userInfo.email
                })
              } else {
                this.setUserInfo({
                  id: userInfo.userInfo.id,
                  userName: userInfo.userInfo.userName,
                  trueName: userInfo.userInfo.trueName,
                  nickName: userInfo.userInfo.trueName,
                  mobile: userInfo.userInfo.mobile,
                  jifen: 0,
                  avatarUrl: '',
                  email: userInfo.userInfo.email
                })
                this.setCompanyInfo(userInfo.company)
                window.location.reload(-1)
              }
              this.closeWin(1)
            }
          }).finally(() => {
            vLoading.close()
          })
        }
      })
    },
    openWin () {
      this.dialogVisible = true
    },
    closeWin (t) {
      this.$emit('close', t)
      this.ruleForm = {
        userType: 'b2c',
        userName: '',
        passwd: '',
        agree: 0
      }
      this.$refs.ruleForm.clearValidate()
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .loginForm{
  box-sizing: border-box;
  padding:0 15px;
  .el-form-item__label{
    padding:0 0 5px 0 !important;
    line-height: 18px !important;
  }
}
.agreeRow{
  display: flex;
  align-items: center;
}
.rd3Login{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  & .btn{
    display: inline-block;
    margin: 10px 25px;
    width: 42px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/loginBox.vue